import { getIsServerEnv } from '@/shared/modules/environment';

export function getStorageItem<T>(key: string, _default: T): T {
  if (getIsServerEnv()) {
    return _default;
  }
  const rawValue = window.localStorage.getItem(key);
  if (rawValue) {
    return JSON.parse(rawValue) as T;
  }
  return _default;
}

export function setStorageItem(key: string, data: any) {
  if (getIsServerEnv()) {
    console.error(`Trying to set ${key} -> setStorageItem on SSR`);
  }
  window.localStorage.setItem(key, JSON.stringify(data));
}
